import React, { useEffect } from "react";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { InteractionRequiredAuthError } from "@azure/msal-browser";
import { loginRequest } from "./authConfig";

export default function AuthGate({ children }) {
  const { instance, inProgress, accounts } = useMsal();
  const isAuthenticated = useIsAuthenticated();

  useEffect(() => {
    if (inProgress !== "none") return;

    if (!isAuthenticated) {
      instance.loginRedirect(loginRequest);
      return;
    }

    const account =
      instance.getActiveAccount() || accounts[0] || instance.getAllAccounts()[0];
    if (!account) {
      instance.loginRedirect(loginRequest);
      return;
    }

    if (!instance.getActiveAccount()) {
      instance.setActiveAccount(account);
    }
    (async () => {
      try {
        await instance.acquireTokenSilent({
          ...loginRequest,
          account,
        });
      } catch (e) {
        if (e instanceof InteractionRequiredAuthError) {
          instance.loginRedirect(loginRequest);
        } else {
          // optional: log unexpected errors
        }
      }
    })();
  }, [instance, inProgress, isAuthenticated, accounts]);

  if (!isAuthenticated) return     <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', width: '100vw'}}>
               <img className="logo-loader logo-loader--pulse" src="/logo2.svg" alt="Loading" />

          </div>;

  return <>{children}</>;
}


